import { render, staticRenderFns } from "./EmojiSelector.vue?vue&type=template&id=43da5812&"
import script from "./EmojiSelector.vue?vue&type=script&lang=js&"
export * from "./EmojiSelector.vue?vue&type=script&lang=js&"
import style0 from "./EmojiSelector.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports